import { render, staticRenderFns } from "./AxAppSplashScreen.vue?vue&type=template&id=1788e3db&scoped=true&"
import script from "./AxAppSplashScreen.vue?vue&type=script&lang=ts&"
export * from "./AxAppSplashScreen.vue?vue&type=script&lang=ts&"
import style0 from "./AxAppSplashScreen.vue?vue&type=style&index=0&id=1788e3db&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1788e3db",
  null
  
)

export default component.exports